import { ADD_PASSENGERS, UPDATE_PASSENGERS } from '../graphql/mutations/passengers';
//import { history } from '../components/App';


/**
 * Add Passenger
 * 
 *
 * @param {object} client - Apollo client
 * @param {string} bookingId - id of the booking
 * @param {int} pax - number of passengers
 * @param {json} lead - lead passenger payload
 * 
 */
export async function AddPassenger(client, bookingId, pax, lead){
    try{
        const response = await client.mutate({mutation:ADD_PASSENGERS, variables:{bookingId:bookingId, pax:pax, lead:lead}});    
        return response;
    }
    catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            //const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
           // if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    } 
}


/**
 * Update Passenger
 * 
 *
 * @param {object} client - Apollo client
 * @param {string} tmsBookingId - tms booking id
 * @param {string} passengerId - id of the passenger
 * @param {json} data - passenger payload
 * 
 */
export async function UpdatePassenger(client, tmsBookingId, passengerId, data){
    try{
        const response = await client.mutate({mutation:UPDATE_PASSENGERS, variables:{tmsBookingId:tmsBookingId, passengerId:passengerId, data:data}});
        return response;  
    }
    catch({graphQLErrors}){
        if(graphQLErrors !== undefined){
            const hasResponseUrl = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.url : "";
            //const hasReponseStatus = (graphQLErrors[0].extensions.response !== undefined) ? graphQLErrors[0].extensions.response.status : "";
            console.error(`${graphQLErrors[0].message} : ${hasResponseUrl}`);
            //if(hasReponseStatus === 500) history.push("/500");
            return graphQLErrors[0].message;
        }
    } 
}